/**
 * Returns a new array with cancelled items moved to the end while preserving
 * the relative order within each group — mirrors GSSP's
 * `moveCancelledPoliciesToEnd` so a cancelled plan/contract still appears in
 * a multi-plan list but never displaces an active one from a prominent
 * (earlier) position. `isCancelled` is caller-supplied so this stays generic
 * across `IPlan`, `PlanDetail`, contract DTOs, etc. — no coupling to a single
 * status field shape.
 */
export function moveCancelledToEnd<T>(items: T[], isCancelled: (item: T) => boolean): T[] {
  if (!items?.length) {
    return items ?? [];
  }

  const active: T[] = [];
  const cancelled: T[] = [];

  items.forEach((item) => (isCancelled(item) ? cancelled.push(item) : active.push(item)));

  return [...active, ...cancelled];
}
